import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ProgressSpinnerService } from './services/progress-spinner.service';

@Component({
  selector: 'app-progress-spinner',
  templateUrl: './progress-spinner.component.html',
  styleUrls: ['./progress-spinner.component.scss'],
  imports: [CommonModule, ProgressSpinnerModule],
})
export class ProgressSpinnerComponent {
  isProgressSpinnerShown$ = this.progressSpinnerService.isProgressSpinnerShown$;

  constructor(
    private readonly progressSpinnerService: ProgressSpinnerService
  ) {}
}
